/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Desired_Tech_SkillsInputs */

const en_job_form_desired_tech_skills = /** @type {(inputs: Job_Form_Desired_Tech_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desired Tech Skills`)
};

const de_job_form_desired_tech_skills = /** @type {(inputs: Job_Form_Desired_Tech_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weitere gewünschte IT-Kenntnisse`)
};

/**
* | output |
* | --- |
* | "Desired Tech Skills" |
*
* @param {Job_Form_Desired_Tech_SkillsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const job_form_desired_tech_skills = /** @type {((inputs?: Job_Form_Desired_Tech_SkillsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Desired_Tech_SkillsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_desired_tech_skills(inputs)
	return en_job_form_desired_tech_skills(inputs)
});